import { CaretDownFilled } from "@ant-design/icons";
import type {
  FormItemProps,
  InputProps,
  RadioGroupProps,
  SelectProps,
} from "antd";
import { DatePicker, Form, Input, Radio, Select } from "antd";
import React from "react";
import HideIcon from "./icons/HideIcon";
import ShowIcon from "./icons/ShowIcon";
import "./style.scss";

const { Option } = Select;

export type inputType = {
  formItemProps?: FormItemProps;
  inputProps?: InputProps;
  formItemType?: "select" | "text" | "datepicker" | "radio" | "password";
  selectProps?: SelectProps;
  selectOptions?: { label: string; value: string | number }[];
  datepickerProps?: any;
  radioProps?: RadioGroupProps;
  radioOptions?: { label: string; value: string | number }[];
};

const CustomInput: React.FC<inputType> = ({
  formItemProps,
  inputProps,
  formItemType = "text",
  selectProps,
  selectOptions = [],
  datepickerProps,
  radioProps,
  radioOptions,
}) => {
  const [passwordVisible, setPasswordVisible] = React.useState(false);

  const renderInput = () => {
    switch (formItemType) {
      case "text":
        return <Input {...inputProps} />;
      case "select":
        return (
          <Select
            {...selectProps}
            suffixIcon={<CaretDownFilled style={{ fontSize: "20px" }} />}
          >
            {selectOptions?.map((item) => (
              <Option key={item.value} value={item.value}>
                {item.label}
              </Option>
            ))}
          </Select>
        );
      case "datepicker":
        return <DatePicker {...datepickerProps} />;
      case "radio":
        return (
          <Radio.Group {...radioProps}>
            {radioOptions?.map((item) => (
              <Radio key={item.value} value={item.value}>
                {item.label}
              </Radio>
            ))}
          </Radio.Group>
        );
      case "password":
        return (
          <Input.Password
            {...inputProps}
            visibilityToggle={{
              visible: passwordVisible,
              onVisibleChange: setPasswordVisible,
            }}
            iconRender={(visible) =>
              visible ? (
                <ShowIcon
                  onClick={() => setPasswordVisible((prevState) => !prevState)}
                />
              ) : (
                <HideIcon
                  onClick={() => setPasswordVisible((prevState) => !prevState)}
                />
              )
            }
          />
        );
      default:
        return <Input {...inputProps} />;
    }
  };

  return (
    <Form.Item
      style={{
        flex: 1,
      }}
      className="Esim-Input"
      {...formItemProps}
    >
      {renderInput()}
    </Form.Item>
  );
};

export default CustomInput;
